import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ProfilePage } from "./pages/ProfilePage";

function ProfileRoute() {
  const { storeSlug = "" } = useParams();
  return <ProfilePage storeSlug={storeSlug} />;
}

export const profileRoutes: RouteObject[] = [
  {
    path: "profile",
    element: <ProfileRoute />,
  },
];
